import { createContext } from "react";

const profilesContext = createContext();

export default profilesContext;
